import binarySearchString from "./binarySearchString";

// Helper function to blocks information, this returns a block and his link in and out with others blocks
const getBlockInformation = (id, blocks, paths)  => {

    const position = binarySearchString(blocks, id, 'object_id');

    const block = {...blocks[position]};

    const paths_out = paths.filter( path => path.parent_block_id == id);

    const paths_in = block.children ? block.children.map(child => paths.find( path => path.child_block_id == child.object_id)).filter( path => path != undefined) : [];

    return {block, paths_out, paths_in, position}
}

export default getBlockInformation;